import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

// ── Customer Model ────────────────────────────────────────────────
export interface CustomerModel {
  firstName: string;
  middleName: string;
  lastName: string;
  phone: string;
  landline: string;
  email: string;
  address: string;
  addressExtra: string;
  city: string;
  birthDate: string;
  nationalId: string;
  membershipNumber: number | null;
  accessCode: string;
  location: string;
  bank: string;
  salesManager: string;
  trainer: string;
  company: string;
  gender: string;
  emergencyName: string;
  emergencyPhone: string;
}

// ── Dialog Input Data ─────────────────────────────────────────────
export interface EditCustomerDialogData {
  customer?: Partial<CustomerModel>; // existing data (view mode)
  editMode?: boolean; // true = open in edit mode directly
}
@Component({
  selector: "fury-edit-customer",
  templateUrl: "./edit-customer.component.html",
  styleUrls: ["./edit-customer.component.scss"],
})
export class EditCustomerComponent {
  // ── Edit Mode Flag ──────────────────────────────────────────────
  isEditMode: boolean = false;

  // ── Photo ───────────────────────────────────────────────────────
  photoPreview: string | null = null;
  selectedFileName: string = "";

  // ── Customer Data ───────────────────────────────────────────────
  customer: CustomerModel = {
    firstName: "",
    middleName: "",
    lastName: "",
    phone: "",
    landline: "",
    email: "",
    address: "",
    addressExtra: "",
    city: "Cairo",
    birthDate: "",
    nationalId: "",
    membershipNumber: null,
    accessCode: "",
    location: "TestBranch",
    bank: "Egypt",
    salesManager: "testusernewui",
    trainer: "None",
    company: "None",
    gender: "ذكر",
    emergencyName: "",
    emergencyPhone: "",
  };

  constructor(
    private dialogRef: MatDialogRef<EditCustomerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditCustomerDialogData,
  ) {}

  ngOnInit(): void {
    // Apply passed-in data
    if (this.data?.customer) {
      this.customer = { ...this.customer, ...this.data.customer };
    }

    // Set initial edit mode from flag (default = view mode)
    this.isEditMode = this.data?.editMode ?? false;

    // Default birth date if empty
    if (!this.customer.birthDate) {
      const today = new Date();
      this.customer.birthDate = today.toISOString().split("T")[0];
    }
  }

  // ── Enable Edit ────────────────────────────────────────────────
  enableEdit(): void {
    this.isEditMode = true;
  }

  // ── File Upload ────────────────────────────────────────────────
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      this.selectedFileName = file.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.photoPreview = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  openCamera(): void {
    console.log("تجهيز الكاميرا...");
    // TODO: implement camera integration
  }

  capturePhoto(): void {
    console.log("إلتقاط الصورة...");
    // TODO: implement capture logic
  }

  // ── Submit ─────────────────────────────────────────────────────
  onSubmit(): void {
    const payload = {
      customer: { ...this.customer },
      photo: this.photoPreview,
    };
    console.log("حفظ بيانات العميل:", payload);
    this.dialogRef.close(payload);
  }

  // ── Close ──────────────────────────────────────────────────────
  onClose(): void {
    this.dialogRef.close(null);
  }
}
